import SignInForm from '@/components/forms/sign-in-form';

const SignInPage = () => {
  return <SignInForm />;
};

export default SignInPage;
